export function getObjectDetailUrl(objectName: string, id: string) {
  const { location } = window;
  const env = location.hostname.split('.')[0];
  const url = `${location.origin.replace(`${env}.`, '')}/admin/${objectName}/${id}/change`;
  return url;
}
